import {
  MarketParticipantStatus,
  MarketParticipantType,
  type OrganisationFilterResponse,
  type OrganisationSearchResponse,
} from '../generated/model';

export const createMarketPartyRegistryOrganisation = (
  overrides: Partial<OrganisationFilterResponse> = {},
): OrganisationFilterResponse => ({
  id: '1',
  statutoryName: 'Adviesgroep Nieuwegein B.V.',
  subunitNames: 'Adyen',
  marketRole: MarketParticipantType.CTO,
  ean13: '1234567890123',
  validStartDate: '2024-01-01',
  status: MarketParticipantStatus.Active,
  ...overrides,
});

export const createMarketPartyRegistryOrganisations = (
  overrides: Partial<OrganisationSearchResponse> = {},
): OrganisationSearchResponse => ({
  items: [
    createMarketPartyRegistryOrganisation(),
    createMarketPartyRegistryOrganisation({
      id: '2',
      statutoryName: 'Eneco B.V.',
      subunitNames: 'Eneco',
      marketRole: MarketParticipantType.EZ,
      ean13: '1234567890124',
      validStartDate: '2024-01-01',
      status: MarketParticipantStatus.Cancelled,
    }),
    createMarketPartyRegistryOrganisation({
      id: '2',
      statutoryName: 'Greenchoice B.V.',
      subunitNames: 'Greenchoice Gas',
      marketRole: MarketParticipantType.EZ,
      ean13: '1234567890124',
      validStartDate: '2024-01-01',
      status: MarketParticipantStatus.Ended,
    }),
  ],
  totalCount: 3,
  availableFilters: {
    marketRoles: [MarketParticipantType.CTO, MarketParticipantType.EZ],
    statuses: [
      MarketParticipantStatus.Active,
      MarketParticipantStatus.Cancelled,
      MarketParticipantStatus.Ended,
    ],
  },
  ...overrides,
});
